import { Tabs, type TabsTabProps } from "@mantine/core";

type Props = {
  children: React.ReactNode;
} & Omit<TabsTabProps, "children">;

export function Tab({ children, ...tabsTabProps }: Props) {
  const defaultOption: Omit<TabsTabProps, "children" | "value"> = {};
  const option = Object.assign(
    {
      styles: {
        tab: {
          backgroundColor: "white",
        },
      },
    },
    defaultOption,
    tabsTabProps,
  );
  return <Tabs.Tab {...option}>{children}</Tabs.Tab>;
}
